import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Icon,
  Text,
  useDisclosure
} from '@chakra-ui/react';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { FiPlusCircle } from 'react-icons/fi';
import { Button } from '../../../../../../components/Button';
import { ProductItem } from './ProductItem';
import * as T from '../../../../../../components/Table';
import { format } from 'date-fns';

export function EstoqueDisponivel({ product, handleSelectProduct, productSelected }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  function handleOpen() {
    onOpen();
  }

  return (
    <>
      <Flex
        onClick={handleOpen}
        alignItems="center"
        justifyContent="center"
        color="#378BBF"
        gap={1}
        cursor="pointer">
        <FiPlusCircle size={20} />
        Estoque disponível
      </Flex>
      <Drawer isOpen={isOpen} placement="bottom" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent minH="100vh">
          <DrawerHeader px={0} borderBottom="1px solid #CFCFCF">
            <Text
              maxW="1200px"
              w="full"
              mx="auto"
              textAlign="center"
              textTransform="uppercase"
              color="#378BBF"
              fontSize="13px"
              fontWeight="semibold">
              Estoque Disponível
            </Text>
          </DrawerHeader>

          <DrawerBody
            maxW="1200px"
            w="full"
            mx="auto"
            px={0}
            display="flex"
            justifyContent="space-between"
            alignItems="center">
            <ProductItem
              item={product}
              handleSelectProduct={handleSelectProduct}
              productSelected={productSelected}
            />

            <T.Table
              maxW="703px"
              fontSize="13px"
              borderCollapse="collapse"
              variant="simple"
              border="1px solid #CFCFCF">
              <T.Tbody>
                {product.cores.map((cor, index) => (
                  <T.Tr key={cor.hex}>
                    <T.Td
                      bg={index % 2 === 0 ? '#EDF2F7' : 'transparent'}
                      borderRight="1px solid #CFCFCF"
                      py={1}
                      sx={{
                        borderBottom:
                          index === product.cores.length - 1
                            ? '1px solid #CFCFCF!important'
                            : 'none'
                      }}>
                      <Flex alignItems="center" justifyContent="start" gap={1}>
                        <Flex
                          alignItems="center"
                          justifyContent="center"
                          w="20px"
                          h="20px"
                          borderRadius="50%"
                          border="1px solid #CFCFCF">
                          <Box bg={cor.hex} p={'5px'} borderRadius="50%" />
                        </Flex>
                        <Text textTransform="uppercase">{cor.name}</Text>
                      </Flex>
                    </T.Td>
                    <T.Td
                      bg={index % 2 === 0 ? '#EDF2F7' : 'transparent'}
                      py={1}
                      borderRight="1px solid #CFCFCF"
                      sx={{
                        borderBottom:
                          index === product.cores.length - 1
                            ? '1px solid #CFCFCF!important'
                            : 'none'
                      }}>
                      Atualizado: {cor.atualizado && format(new Date(cor.atualizado), 'dd/MM/yyyy')}
                    </T.Td>
                    <T.Td
                      bg={index % 2 === 0 ? '#EDF2F7' : 'transparent'}
                      py={1}
                      borderRight="1px solid #CFCFCF"
                      sx={{
                        borderBottom:
                          index === product.cores.length - 1
                            ? '1px solid #CFCFCF!important'
                            : 'none'
                      }}>
                      Disponivel:{' '}
                      {cor.quantidade_disponivel &&
                        new Intl.NumberFormat('pt-BR').format(cor.quantidade_disponivel)}
                    </T.Td>
                    <T.Td
                      bg={index % 2 === 0 ? '#EDF2F7' : 'transparent'}
                      py={1}
                      sx={{
                        borderBottom:
                          index === product.cores.length - 1
                            ? '1px solid #CFCFCF!important'
                            : 'none'
                      }}>
                      Reposição:{' '}
                      {cor?.data_reposicao !== null
                        ? format(new Date(cor.data_reposicao), 'dd/MM/yyyy')
                        : 'Não informado '}
                      |{' '}
                      {cor.quantidade_repicao
                        ? new Intl.NumberFormat('pt-BR').format(cor.quantidade_repicao)
                        : 'Não informado'}
                    </T.Td>
                  </T.Tr>
                ))}
              </T.Tbody>
            </T.Table>
          </DrawerBody>

          <DrawerFooter
            position="sticky"
            bottom="0"
            boxShadow="0px -1px 4px rgba(0, 0, 0, 0.1)"
            mt="auto">
            <Flex
              alignItems="center"
              justifyContent="space-between"
              maxW="1200px"
              w="full"
              mx="auto">
              <Button
                variant="outline"
                mr={3}
                onClick={onClose}
                w="181px"
                bg="transparent"
                color="#378BBF">
                <Icon as={AiOutlineArrowLeft} mr={2} color="#378BBF" />
                Voltar
              </Button>
            </Flex>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}
